module.exports = __webpack_public_path__ + "img/logo-wbooking.c3c1e762.svg";